import { AbstractControl } from '@angular/forms';

export default (control: AbstractControl) => {
  const days = control.get('days');

  if (!days) {
    return null;
  }

  return (<number[]>days.value).length > 0 ? null : { noDays: true };
};
